import { Button, Menu, MenuItem, MenuPopover, MenuTrigger } from "@fluentui/react-components";
import PersonOutlineIcon from "~icons/material-symbols/person-outline";
import LogoutIcon from "~icons/material-symbols/logout";
import { memo } from "react";
import { useAuth } from "../../../hooks";
import { useAccountMenuStyles } from "../styles/AccountMenu.styles";

export const AccountMenu = memo(() => {
  const styles = useAccountMenuStyles();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div className={styles.settingsContainer}>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button appearance="primary" shape="circular" icon={<PersonOutlineIcon />}></Button>
        </MenuTrigger>
        <MenuPopover>
          <MenuItem icon={<LogoutIcon />} onClick={handleLogout}>
            Logout
          </MenuItem>
        </MenuPopover>
      </Menu>
    </div>
  );
});
